module.exports = __webpack_public_path__ + "img/06933939000780.8323ecd3.png";